import {Component, Module} from 'app/decorators';
import tpl from './tanks.picker.html';


@Module({
    name: "app.directives.tanks.picker",
})
@Component({
    selector: 'blnd-tanks',
    bindings: {
        ngModel: '=',
        mode: '@?',
    },
    template: tpl,
})
export default class C {
    constructor () {
        this.mode = this.mode || 'view';
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/tanks.picker.js